module.exports = __webpack_public_path__ + "6e1587027f6fd4e7f556253d1420885c.png";